module.exports = __webpack_public_path__ + "static/media/ban-square.24f6dbc0.png";